import React from "react";
import Styles from './styles.module.scss';
import RoadmapMobile from "../_UI/roadmapMobile";
import RoadmapDesktop from "../_UI/roadmapDesktop";
import {useTranslation} from "react-i18next";



const CabinetRoadmapMain = () => {
    const { t } = useTranslation();
    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.ftfCard}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Дорожная карта')}</div>
                <div className={`${Styles.contentWrapNote}`}>
                    {t('Добро пожаловать в систему из 15 инвестиционных кругов — продуманный и открытый путь роста нашего токена. Каждый круг — это шаг вперёд: фиксированная цена, понятный объём эмиссии и чёткие правила, доступные каждому участнику. Ты можешь в любой момент видеть, на каком этапе находится проект, сколько токенов выпущено, какой спрос, и какие возможности открываются прямо сейчас')}.
                </div>
                <div className={`${Styles.roadmapWrap}`}>
                    <div className={`${Styles.roadmapMobile}`}>
                        <RoadmapMobile/>
                    </div>
                    <div className={`${Styles.roadmapDesktop}`}>
                        <RoadmapDesktop/>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetRoadmapMain;